var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import mixinClassNames from "../../utilities/mixinClassNames.js";
import { mixinStyles } from "@bookingcom/bui-core/utilities/styles";
import Text, {} from "../Text/index.js";
import styles from "@bookingcom/bui-core/css/Title.module.css";
var subtitleVariantMap = {
    strong_1: "body_2",
    strong_2: "small_1",
    headline_3: "body_1",
    headline_2: "body_1",
    headline_1: "body_1",
    display_3: "featured_2",
};
var Title = function (props) {
    var reversed = props.reversed, title = props.title, subtitle = props.subtitle, className = props.className, attributes = props.attributes, titleAttributes = props.titleAttributes, subtitleAttributes = props.subtitleAttributes, titleTagName = props.titleTagName, subtitleTagName = props.subtitleTagName, titleClassName = props.titleClassName, subtitleClassName = props.subtitleClassName, _a = props.tagName, tagName = _a === void 0 ? "div" : _a, _b = props.variant, variant = _b === void 0 ? "strong_2" : _b, color = props.color, mixin = props.mixin;
    var rootClassName = classNames(styles.root, className, reversed && styles["root--reversed"], variant && styles["root--variant-".concat(variant)], color && styles["root--color-".concat(color)], mixinClassNames(mixin));
    var rootAttributes = __assign(__assign({}, attributes), { style: __assign(__assign({}, ((attributes === null || attributes === void 0 ? void 0 : attributes.style) || {})), mixinStyles(mixin)) });
    var TagName = tagName;
    var subtitleVariant = subtitleVariantMap[variant];
    var subtitleClassNames = classNames(styles.subtitle, subtitleClassName);
    var titleClassNames = classNames(styles.title, titleClassName);
    return (React.createElement(TagName, __assign({}, rootAttributes, { className: rootClassName }),
        title && (React.createElement(Text, { attributes: titleAttributes, className: titleClassNames, tagName: titleTagName, variant: variant, color: color !== null && color !== void 0 ? color : "neutral" }, title)),
        subtitle && (React.createElement(Text, { attributes: subtitleAttributes, tagName: subtitleTagName, className: subtitleClassNames, variant: subtitleVariant, color: color !== null && color !== void 0 ? color : "neutral_alt" }, subtitle))));
};
export default Title;
